import React, { Component } from 'react';
import Asset from 'src/requests/apa/Asset';
import '../../styles/flag.css';

interface IFlagProps {
    size: string;
    imageFlag: string;
}

export default class Flag extends Component<IFlagProps> {
    size: string;
   constructor(props: IFlagProps) {
        super(props);
        this.size = this.props.size;
    }

    render() {
        const imagAux = this.props.imageFlag || Asset.get('vcard_team_placeholder_img');
        return (
            <div
                id="cardFlag"
                style={{ backgroundImage: `url(${imagAux})` }}
                className={`${this.size}`}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/Flag/Flag.tsx